declare var _orgAjax;
declare var availableCourses;
declare var currentCourse;

import * as jQuery from 'jquery';

import { IDAL, IUser, IUserLocation } from './../services/IDAL';

import { getServerURL, deleteJSESSIONIDcookie, getParameterByName, insertParameter, shouldDebug } from '../api/common'
import { REJECT_PERMISSION_ERROR_403_401, ROLE_IVC_MENTOR, ROLE_USER } from '../constants';

import * as Sentry from '@sentry/browser';

const esprima = require('esprima');
const forcedRefresh: boolean = false;

import {
    ICalendarEvents,
    ISession,
    ITranscribeService
} from '../components/models/models';
import PlatformUtils from './PlatformUtils';



const debug = shouldDebug();
export default class BrowserAdapter implements IDAL {


    URLBase: string;
    newUtils: any;


    constructor() {
        this.URLBase = getServerURL();
        this.newUtils = new Utils();
    }
    
    public addDefaultQuestions(courseId: any) {
        return new Promise<void>((resolve, reject) => {
            this.newUtils.obtainJSONFromURLWithQuery(this.URLBase + `/feedback/addDefaultFeedbackQuestionsToCourse?courseId=${courseId}`, 'POST')
                .then(data => {
                    if(data && data.success){
                        resolve()
                    }
                    else {
                        reject();
                    }
                }).catch(e => reject(e));
        });
    }
    
    public getLiveProjectUserLocations(): Promise<IUserLocation[]> {
        return new Promise<IUserLocation[]>((resolve, reject) => {
            this.newUtils.obtainJSONFromURL(this.URLBase + "/group/getLpMembersData", 'GET')
                .then(data => resolve(data))
                .catch(e => resolve([]));
        });
    }

    private static courseAuthorsPromise: Promise<any>;
    public getCourseAuthors(courseId: number): Promise<IUser[]> {
        if (BrowserAdapter.courseAuthorsPromise) {
            return BrowserAdapter.courseAuthorsPromise;
        }
        return BrowserAdapter.courseAuthorsPromise = new Promise<IUser[]>((resolve, reject) => {
            this.newUtils.obtainJSONFromURLWithQuery(this.URLBase + '/user/getCourseAuthors', 'POST', JSON.stringify({ courseId: courseId }), false)
                .then(JSONContent => resolve(JSONContent))
                .catch(error => {
                    BrowserAdapter.courseAuthorsPromise = null;
                    reject(error)
                });
        });
    }

    private static courseMentorsPromise: Promise<any>;
    public getCourseMentors(courseId: number): Promise<IUser[]> {
        if (BrowserAdapter.courseMentorsPromise) {
            return BrowserAdapter.courseMentorsPromise;
        }
        return BrowserAdapter.courseMentorsPromise = new Promise<IUser[]>((resolve, reject) => {
            this.newUtils.obtainJSONFromURLWithQuery(this.URLBase + '/user/getCourseMentors', 'POST', JSON.stringify({ courseId: courseId }), false)
                .then(JSONContent => resolve(JSONContent))
                .catch(error => reject(error));
        });
    }

    public updateAuthorMentorDetails(userId: number, description: string, avatarUrl: string): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            let url = this.URLBase + '/user/setAuthorMentorInfo';
            let method = 'POST';

            let query = JSON.stringify({
                userId: userId,
                description: description,
                avatarUrl: avatarUrl,
            });

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                resolve();
            }).catch(error => reject(error));
        });
    }

    private static allCoursesPromise: Promise<any>;
    public listAllCourses(course_type?: string): Promise<any> {
        if (BrowserAdapter.allCoursesPromise) {
            return BrowserAdapter.allCoursesPromise;
        }
        return BrowserAdapter.allCoursesPromise = new Promise((resolve, reject) => {
            let url = this.URLBase + '/course/listAllCourses';
            let method = 'POST';

            let queryObject = course_type ? {
                course_type: course_type,
            } : {};
            let query = JSON.stringify(queryObject);

            if (debug) console.log("%clistAllCourses ", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => {
                BrowserAdapter.allCoursesPromise = null;
                reject(error)
            });
        });
    }

    public generateGroupsForSection(courseManningId: number, sessionId: number): Promise<void> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/group/generateGroupsForSection';
            let method = 'POST';

            let query = JSON.stringify({
                productId: courseManningId,
                sessionId: sessionId
            });

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }

    private static availableCoursesPromise: { [key: string]: Promise<any> } = {};
    public listAvailableCourses(course_type?: string): Promise<any> {
        const mapId = `${course_type}`
        if (BrowserAdapter.availableCoursesPromise[mapId]) {
            return BrowserAdapter.availableCoursesPromise[mapId];
        }
        return BrowserAdapter.availableCoursesPromise[mapId] = new Promise((resolve, reject) => {
            let url = this.URLBase + '/course/listAvailableCourses';
            let method = 'POST';

            let queryObject = course_type ? {
                course_type: course_type,
            } : {};
            let query = JSON.stringify(queryObject);

            if (debug) console.log("%clistAvailableCourses", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, true).then(JSONContent => {
                availableCourses = JSONContent?.courses;
                let foundErrorCourses = availableCourses?.filter(it => it.manningId == null);
                if (foundErrorCourses.length) {
                    Sentry?.configureScope((scope) => {
                        let message = foundErrorCourses?.map(it => it.id)?.join(",");
                        let sentryLog = `missing manningId`;
                        Sentry.addBreadcrumb({
                            category: 'WRONG_INDEXES',
                            message: message,
                        });
                        Sentry.captureException("WRONG_INDEXES " + sentryLog);
                    });
                }

                resolve(JSONContent);
            }).catch(error => {
                BrowserAdapter.availableCoursesPromise = null;
                reject(error);
            });
        });
    }

    private static ownedCoursesPromise: Promise<any>;
    public listOwnedCourses(course_type?: string): Promise<any> {
        if (BrowserAdapter.ownedCoursesPromise) {
            return BrowserAdapter.ownedCoursesPromise;
        }

        return BrowserAdapter.ownedCoursesPromise = new Promise((resolve, reject) => {
            let url = this.URLBase + '/course/listOwnedCourses';
            let method = 'POST';

            let queryObject = course_type ? {
                course_type: course_type,
            } : {};
            let query = JSON.stringify(queryObject);

            if (debug) console.log("%clistOwnedCourses", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => {
                BrowserAdapter.ownedCoursesPromise = null;
                reject(error)
            });
        });
    }

    private static getDetailsForCoursePromiseMap: { [key: string]: Promise<any> } = {}; // Do not use for main, it will break the site
    public getDetailsForCourseFullCached(courseId: string, unitIdex: string, moduleIndex: string, userRole: string, groupId: number): Promise<any> {
        const mapId = `${courseId}_${unitIdex}_${moduleIndex}_${userRole}_${groupId}`
        if (BrowserAdapter.getDetailsForCoursePromiseMap[mapId]) {
            return BrowserAdapter.getDetailsForCoursePromiseMap[mapId];
        }
        return BrowserAdapter.getDetailsForCoursePromiseMap[mapId] = new Promise((resolve, reject) => {

            let url = this.URLBase + '/course/getDetailsForCourse';
            let method = 'POST';
            let user_role = userRole != null ? userRole.replace("userRoles/", "") : "";
            let queryObject: any = {
                id: courseId,
                module_index: moduleIndex,
                unit_index: unitIdex,
                user_role: user_role,
            }

            if (groupId != null) {
                queryObject = {
                    ...queryObject,
                    group_id: groupId,
                }
            }

            let query = JSON.stringify(queryObject);

            if (debug) console.log("%cgetDetailsForCourseFull", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                currentCourse = JSONContent;
                resolve(JSONContent);
            }).catch(error => {
                BrowserAdapter.getDetailsForCoursePromiseMap[mapId] = null;
                reject(error)
            });
        });
    }

    public getDetailsForCourseFull(courseId: string, unitIdex: string, moduleIndex: string, userRole: string, groupId: number): Promise<any> {
        return new Promise((resolve, reject) => {

            let url = this.URLBase + '/course/getDetailsForCourse';
            let method = 'POST';
            let user_role = userRole != null ? userRole.replace("userRoles/", "") : "";
            let queryObject: any = {
                id: courseId,
                module_index: moduleIndex,
                unit_index: unitIdex,
                user_role: user_role,
            }

            if (groupId != null) {
                queryObject = {
                    ...queryObject,
                    group_id: groupId,
                }
            }

            let query = JSON.stringify(queryObject);

            if (debug) console.log("%cgetDetailsForCourseFull", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }



    private static getCourseStructurePromiseMap: { [key: string]: Promise<any> } = {};
    public getCourseStructure(courseId: string, userRoles: string[]): Promise<any> {
        const mapId = `${courseId}_${userRoles?.join()}`
        if (BrowserAdapter.getCourseStructurePromiseMap[mapId]) {
            return BrowserAdapter.getCourseStructurePromiseMap[mapId];
        }
        return BrowserAdapter.getCourseStructurePromiseMap[mapId] = new Promise((resolve, reject) => {

            let url = this.URLBase + '/course/getCourseStructure';
            if (userRoles == null) userRoles = [];
            let user_roles = userRoles.map(role => role.replace("userRoles/", ""));
            let method = 'POST';
            let queryObject = {
                id: courseId,
                user_roles: user_roles,
            }
            let query = JSON.stringify(queryObject);

            if (debug) console.log("%cgetCourseStructure", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                currentCourse = JSONContent;
                resolve(JSONContent);
            }).catch(error => {
                BrowserAdapter.getCourseStructurePromiseMap[mapId] = null;
                reject(error)
            });
        });
    }

    public getCourseProgressV2(courseId: string): Promise<any> {
        return new Promise((resolve, reject) => {

            let url = this.URLBase + '/course/getCourseProgressV2';
            let method = 'POST';
            let queryObject = {
                id: courseId,
            }
            let query = JSON.stringify(queryObject);

            if (debug) console.log("%cgetCourseProgressV2", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }

    public getModuleDuration(courseId: any, unitIdex: any, moduleIndex: any): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/module/getModuleDuration';
            let method = 'POST';
            let queryObject = {
                course_id: courseId,
                module_index: moduleIndex,
                unit_index: unitIdex
            }
            let query = JSON.stringify(queryObject);

            if (debug) console.log("%cgetModuleDuration", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { resolve(error) })
        });
    }

    public extractModuleDurationsForCourse(JSONquery: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/course/extractModuleDurationsForCourse';
            let method = 'POST';

            if (debug) console.log("%cextractModuleDurationsForCourse", 'background: #ffbf00; color: black');

            this.newUtils.sendJSONQueryToURL(url, method, JSONquery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    public reloadFullCourseDownloadFile(JSONquery: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/course/reloadFullCourseDownloadFile';
            let method = 'POST';

            if (debug) console.log("%creloadFullCourseDownloadFile", 'background: #ffbf00; color: black');

            this.newUtils.sendJSONQueryToURL(url, method, JSONquery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    public getBestsellers(numberOfBestSellers?: number): Promise<any> {
        return new Promise((resolve, reject) => {

            let url = this.URLBase + '/course/getBestsellers';
            let method = 'POST';

            let queryObject = numberOfBestSellers ? {
                max: numberOfBestSellers,
            } : {

                }
            let query = JSON.stringify(queryObject);

            if (debug) console.log("%cgetBestsellers", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, true).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }

    public invalidateCourse(courseId: string): Promise<any> {
        return new Promise((resolve, reject) => {

            let url = this.URLBase + '/course/invalidateCourse';
            let method = 'POST';
            let queryObject = {
                id: courseId,
            }
            let query = JSON.stringify(queryObject);

            if (debug) console.log("%cinvalidateCourse", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });


        });
    }

    public updateFiles(courseId: string): Promise<any> {
        return new Promise((resolve, reject) => {

            let url = this.URLBase + '/course/updateFiles';
            let method = 'POST';
            let queryObject = {
                course_id: courseId,
            }
            let query = JSON.stringify(queryObject);

            if (debug) console.log("%cupdateFiles", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });


        });
    }


    public updateExercisesForCurrentModuleFromJSON(courseId: string, unitId: string, moduleId: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = '/src/resources/exercises/' + courseId + '/' + unitId + '/' + moduleId + '/quiz.json';

            if (debug) console.log("%cupdateExercisesForCurrentModuleFromJSON", 'background: #ffbf00; color: black');

            this.newUtils.obtainResultFromJSONOnS3Server(url).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });


        });
    }



    public getNewS3Folders(): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/s3courses/index';
            let method = 'GET';

            if (debug) console.log("%cgetNewS3Folders", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURL(url, method, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });


        });
    }

    public getDetailsForS3Course(folderName: string, createMissingVtts: boolean): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/s3courses/getDetailsForS3Course';
            let method = 'POST';
            let queryObject = {
                courseName: folderName,
                createMissingVtts: createMissingVtts,
            }
            let query = JSON.stringify(queryObject);

            if (debug) console.log("%cgetDetailsForS3Course", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });


        });
    }

    public setMetadataForVtt(folderName: string): Promise<any> {
        return new Promise((resolve, reject) => {

            let url = this.URLBase + '/s3courses/setMetadataForVtt';
            let method = 'POST';
            let queryObject = {
                courseName: folderName,
            }
            let query = JSON.stringify(queryObject);

            if (debug) console.log("%csetMetadataForVtt", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });


        });
    }

    public deleteCourse(courseId: any): Promise<boolean> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/course/archiveCourse';
            let method = 'POST';
            let queryObject = {
                id: courseId,
            }
            let query = JSON.stringify(queryObject);

            if (debug) console.log("%cdeleteCourse", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }

    public editCourse(JSONquery: string): Promise<boolean> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/course/editCourse';
            let method = 'POST';

            if (debug) console.log("%ceditCourse", 'background: #ffbf00; color: black');

            this.newUtils.sendJSONQueryToURLWithErrorResponse(url, method, JSONquery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }


    public createNewCourseV3(name: string, createOnMarketplace: boolean, is_hybrid: boolean, publisher: string, is_mini_lv: boolean, is_from_s3: boolean, s3_path?: string, course_type?: string): Promise<any> {
        return new Promise((resolve, reject) => {

            let url = this.URLBase + '/course/createNewCourseV3';
            let method = 'POST';

            var query_temp: any = {
                name: name,
                is_hybrid: is_hybrid,
                publisher: publisher,
                is_mini_lv: is_mini_lv,
                is_from_s3: is_from_s3,
                s3_path: s3_path,
                createOnMarketplace: createOnMarketplace,
                course_type: course_type,
            }

            let queryJSON = JSON.stringify(query_temp);

            if (debug) console.log("%ccreateNewCourseV3", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, queryJSON, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(
                error => { reject(error) }
            );
        });
    }



    public listImagesFromS3(courseName: string): Promise<boolean> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/s3courses/listImagesFromS3';
            let method = 'POST';

            let queryObject = {
                courseName: courseName,
            }
            let query = JSON.stringify(queryObject);

            if (debug) console.log("%clistImagesFromS3", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }

    public listScreenshotsFromS3(courseName: string): Promise<boolean> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/s3courses/listScreenshotsFromS3';
            let method = 'POST';

            let queryObject = {
                courseName: courseName,
            }
            let query = JSON.stringify(queryObject);

            if (debug) console.log("%clistScreenshotsFromS3", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }

    public uploadImageToS3(imageName: string, courseName: string, image: string): Promise<boolean> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/s3courses/uploadImageToS3';
            let method = 'POST';

            var queryObject = {
                "imageName": imageName,
                "courseName": courseName,
                "image": image,
            };


            var query = JSON.stringify(queryObject)

            if (debug) console.log("%cuploadImageToS3", 'background: #ffbf00; color: black');

            this.newUtils.sendJSONQueryToURL(url, method, query, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    createVideoScreenshotOnS3(video_src: string, courseName: string, unit_index: string, module_index: string, timestamp: string): Promise<boolean> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/s3courses/createVideoScreenshotOnS3';
            let method = 'POST';

            var queryObject = {
                "video_src": video_src,
                "courseName": courseName,
                "unit_index": unit_index,
                "module_index": module_index,
                "timestamp": timestamp
            };


            var query = JSON.stringify(queryObject)

            if (debug) console.log("%ccreateVideoScreenshotOnS3", 'background: #ffbf00; color: black');

            this.newUtils.sendJSONQueryToURL(url, method, query, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    public updateModule(jsonQuery: string): Promise<boolean> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/module/updateModule';
            let method = 'POST';

            if (debug) console.log("%cupdateModule", 'background: #ffbf00; color: black');

            this.newUtils.sendJSONQueryToURLWithReloginAttempt(url, method, jsonQuery).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    public getTocElementPrices(course_id: number): Promise<boolean> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/tokens/getTocElementPrices';
            let method = 'POST';

            let queryObject = {
                course_id: course_id,
            }
            let query = JSON.stringify(queryObject);

            if (debug) console.log("%cgetTocElementPrices", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }

    public cashout(): Promise<boolean> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/tokens/cashout';
            let method = 'POST';

            let queryObject = {
            }
            let query = JSON.stringify(queryObject);

            if (debug) console.log("%ccashout", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }

    public getCashoutInfo(): Promise<boolean> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/tokens/getCashoutInfo';
            let method = 'POST';

            let queryObject = {
            }
            let query = JSON.stringify(queryObject);

            if (debug) console.log("%cgetCashoutInfo", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }


    public getUnlockedStatusForTocElements(course_id: number): Promise<boolean> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/tokens/getUnlockedStatusForTocElements';
            let method = 'POST';

            let queryObject = {
                course_id: course_id,
            }
            let query = JSON.stringify(queryObject);

            if (debug) console.log("%cgetUnlockedStatusForTocElements", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }

    public getElementPrices(course_id: number, unit_index: number, module_index?: number): Promise<boolean> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/tokens/getElementPrices';
            let method = 'POST';

            let queryObject = module_index != null ? {
                course_id: course_id,
                unit_index: unit_index,
                module_index: module_index,
            } : {
                    course_id: course_id,
                    unit_index: unit_index,
                }
            let query = JSON.stringify(queryObject);

            if (debug) console.log("%cgetElementPrices", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }

    public getTokenProductOffering(): Promise<boolean> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/tokens/getTokenProductOffering';
            let method = 'POST';

            let queryObject = {
            }

            let query = JSON.stringify(queryObject);

            if (debug) console.log("%cgetTokenProductOffering", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }

    public getParagraphPrices(course_id: number, unit_id: number, module_id: number): Promise<boolean> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/tokens/getParagraphPrices';
            let method = 'POST';

            let queryObject = {
                course_id: course_id,
                unit_index: unit_id,
                module_index: module_id,
            }
            let query = JSON.stringify(queryObject);

            if (debug) console.log("%cgetParagraphPrices", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }

    public saveNotificationPreferences(accept: boolean): Promise<boolean> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/api/comment/saveNotificationPreferences';
            let method = 'POST';

            let queryObject = {
                value: accept,
            }
            let query = JSON.stringify(queryObject);

            if (debug) console.log("%csaveNotificationPreferences", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }


    public getTokenLedger(): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/api/token/getTokenLedger';
            let method = 'GET';

            if (debug) console.log("%cgetTokenLedger", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURL(url, method, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }

    public addInfiniteLoopProtection(code) {
        var loopId = 1;
        var patches = [];
        var varPrefix = '_wmloopvar';
        var varStr = 'var %d = Date.now();\n'
        var checkStr = '\nif (Date.now() - %d > 1000) { console.log("Infinite loop"); break;}\n'

        esprima.parse(code, { tolerant: true, range: true, jsx: true }, function (node) {
            switch (node.type) {
                case 'DoWhileStatement':
                case 'ForStatement':
                case 'ForInStatement':
                case 'ForOfStatement':
                case 'WhileStatement':
                    var start = 1 + node.body.range[0];
                    var end = node.body.range[1];
                    var prolog = checkStr.replace('%d', varPrefix + loopId);
                    var epilog = '';

                    if (node.body.type !== 'BlockStatement') {
                        // `while(1) doThat()` becomes `while(1) {doThat()}`
                        prolog = '{' + prolog;
                        epilog = '}';
                        --start;
                    }

                    patches.push({ pos: start, str: prolog });
                    patches.push({ pos: end, str: epilog });
                    patches.push({ pos: node.range[0], str: varStr.replace('%d', varPrefix + loopId) });
                    ++loopId;
                    break;

                default:
                    break;
            }
        });

        /* eslint-disable no-param-reassign */
        patches.sort(function (a, b) { return b.pos - a.pos }).forEach(function (patch) {
            code = code.slice(0, patch.pos) + patch.str + code.slice(patch.pos);
        });

        /* eslint-disable no-param-reassign */
        return code;
    }

    /*public processAst(ast) {
        var currentElement;
        // If this ins't actual body, recurse with the body
        if (!Array.isArray(astBody)) {
            this.processAst(astBody.body);
            return;
        }
        // Traverse the body
        for (var i = ast.length; i--;) {
            var currentElement = ast[i];

            if (currentElement &&
                currentElement.type === 'ForStatement' ||
                currentElement.type === 'WhileStatement' ||
                currentElement.type === 'DoWhileStatement') {

                var ast1 = esprima.parse('var myvar = Date.now();');
                var ast2 = esprima.parse('while(a){if (Date.now() - myvar > 1000) { break;}}');
                var insertionBlocks = {
                    before: ast1.body[0],
                    inside: ast2.body[0].body.body[0]
                };
                randomVariableName = '_' + generateRandomId(3);
                insertionBLocks.before.declarations[0].id.name = insertionBLocks.inside.test.left.right.name = randomVariableName;

                // Insert time variable assignment as first child in the body array.
                ast.splice(i, 0, insertionBLocks.before);

                // If the loop's body is a single statement, then convert it into a block statement
                // so that we can insert our conditional break inside it.
                if (!Array.isArray(el.body)) {
                    currentElement.body = {
                        body: [ el.body ],
                        type: 'BlockStatement'
                    };
                }

                // Insert the `If` Statement check
                currentElement.body.body.unshift(insertionBLocks.inside);
            }
            // Recurse on inner body
            if (currentElement.body) {
                this.processAst(currentElement.body);
            }
        }
    }*/


    /*public executeTryItYourselfCode(code: string, newCodeCSS:string, newCodeHTML:string, language: string, lambdaName: string): Promise<any> {

        return new Promise((resolve, reject) => {
            let url = this.URLBase+'/code/runTryItYourself';
            let executable = true;
            let method = 'POST';

            var lambdaCode;
            if(lambdaName=="execVueCode"){
                lambdaCode = {
                    "code": code,
                    "vue": newCodeHTML,
                    "lambda_name": lambdaName,
                }
            }
            else{
                lambdaCode = {
                    "code": code,
                    "lambda_name": lambdaName,
                }
            }

            if (lambdaName == "UnknownLambda") {
                alert("Problem with code execution");
            }

            if(!(lambdaName=="javascript") && !(lambdaName=="js/html/css"))
            {
                var query = JSON.stringify(lambdaCode);
                
                if(debug) console.log("%cexecuteTryItYourselfCode", 'background: #ffbf00; color: black');
            
                this.newUtils.sendJSONQueryToURL(url, method, query, false).then(isSuccessful => {
                    resolve(isSuccessful);
                }).catch(error=>{reject(error)});
            }
            else if(lambdaName=="javascript")
            {
                var oldLog = console.log;
                
                var result:any = {};
                var fullMessage = "";
                (function(){
                    
                    var oldErrorLog = console.error;
                    console.log = function (message) {
                        //var args = Array.prototype.slice.call(arguments).join(' ');
                        var args_temp = Array.prototype.slice.call(arguments);
                        var args = "";
                        for(let i=0; i<args_temp.length; i++)
                        { 
                            if(typeof args_temp[i] == "string" || typeof args_temp[i] == "number" || typeof args_temp[i] == "boolean")
                            {
                                args += " " + args_temp[i];
                            }
                            else
                            {
                                args += " " + JSON.stringify(args_temp[i]);
                            }
                        }
                        fullMessage += "<br />"+args;
                        oldLog.apply(console, arguments);
                    };
                })();

            

                let newCode;
                try {
                    newCode = this.addInfiniteLoopProtection(code);
                    eval(newCode); 
                } catch (e) {
                    fullMessage = e.toString();
                }
                console.log = oldLog; //Important
                result.lambda_output = fullMessage;
                resolve(result)

            }
            else if(lambdaName=="js/html/css")
            {
                const latestCode = code || "";
                const latestCSSCode = newCodeCSS || "";
                const latestHTMLCode = newCodeHTML || "";

                var result:any = {};
                result.lambda_output = '<!DOCTYPE html><html><head><meta http-equiv="Content-type" content="text/html; charset=utf-8"><meta http-equiv="X-UA-Compatible" content="IE=edge"><meta name="viewport" content="width=device-width,initial-scale=1"><title></title><style>' + latestCSSCode + '</style></head><body><div id="mountHere"></div>' + latestHTMLCode + '</body><script>' + latestCode + '</script></html>';

                resolve(result)
            }
        });
    }*/


    public takeOverConsole() {
        var console = window.console
        if (!console) return
        function intercept(method) {
            var original = console[method]
            console[method] = function () {
                // do sneaky stuff
                if (original.apply) {
                    // Do this for normal browsers
                    original.apply(console, arguments)
                } else {
                    // Do this for IE
                    var message = Array.prototype.slice.apply(arguments).join(' ')
                    original(message)
                }
            }
        }

        var methods = ['log', 'warn', 'error']
        for (var i = 0; i < methods.length; i++)
            intercept(methods[i])
    }

    public getCodeListingProgrammingLanguages(): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/code/getCodeListingProgrammingLanguages';
            let method = 'POST';

            if (debug) console.log("%cgetCodeListingProgrammingLanguages", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURL(url, method, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }

    /*public getTryItYourselfProgrammingLanguages(): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase+'/code/getTryItYourselfDetails';
            let method = 'POST';
            
            if(debug) console.log("%cgetTryItYourselfProgrammingLanguages", 'background: #ffbf00; color: black');
            
            this.newUtils.obtainJSONFromURL(url, method, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error=>{reject(error)});
        });
    }*/

    public getAllVersions(module_id: string, unit_id: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/module/getAllVersions';
            let method = 'POST';

            var query_temp = {
                "module_id": module_id,
                "unit_id": unit_id,
            }


            var query = JSON.stringify(query_temp);

            if (debug) console.log("%cgetAllVersions", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }

    public getDetailsForModuleVersion(module_id: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/module/getDetailsForModuleVersion';
            let method = 'POST';

            var query_temp = {
                "module_id": module_id,
            }

            var query = JSON.stringify(query_temp);

            if (debug) console.log("%cgetDetailsForModuleVersion", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }

    public restoreToVersion(current_module_id: string, unit_id: string, restore_to_module_id: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/module/restoreToVersion';
            let method = 'POST';

            var query_temp = {
                "current_module_id": current_module_id,
                "unit_id": unit_id,
                "restore_to_module_id": restore_to_module_id,
            }

            var query = JSON.stringify(query_temp);

            if (debug) console.log("%crestoreToVersion", 'background: #ffbf00; color: black');

            this.newUtils.sendJSONQueryToURL(url, method, query, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    public loginUA(username, password): Promise<any> {
        return new Promise((resolve, reject) => {

            let _self = this;

            let url = this.URLBase + '/authentication/login';
            let method = 'POST';

            jQuery.ajax({
                type: method,
                async: true,
                url: url,
                xhrFields: {
                    withCredentials: true
                },
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
                crossDomain: true,
                data: {
                    username: username,
                    password: password
                },
                success: function (output, status, xhr) {
                    resolve(output)
                },
                error: function (request, error) {
                    console.log("logout 7");
                    _self.newUtils.logoutUsingLS();
                },
            });
        });
    }

    public logoutUA(): Promise<any> {
        return new Promise((resolve, reject) => {


            let url = this.URLBase + '/authentication/logout';
            let method = 'POST';

            let _self = this;

            jQuery.ajax({
                type: method,
                async: true,
                url: url,
                xhrFields: {
                    withCredentials: true
                },
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
                crossDomain: true,
                data: {
                },
                success: function (output, status, xhr) {
                    deleteJSESSIONIDcookie();
                    deleteJSESSIONIDcookie();
                    setTimeout(function () {
                        console.log("logout 8");
                        _self.newUtils.logoutUsingLS();
                    }, 1000);
                    resolve(output)
                },
                error: function (request, error) {
                    //console.log(" Can't do because: " + error); 
                    alert("ERROR on logout") //loguit
                    _self.newUtils.logoutUsingLS();
                },
            });


        });
    }

    public updateUserProgress(jsonQuery: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/module/updateUserProgress';
            let method = 'POST';

            if (debug) console.log("%cupdateUserProgress", 'background: #ffbf00; color: black');

            this.newUtils.sendJSONQueryToURL(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    public deleteDeveloperUnscrabmlings(): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/user/deleteDeveloperUnscrabmlings';
            let method = 'POST';

            if (debug) console.log("%cdeleteDeveloperUnscrabmlings", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURL(url, method, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }

    public getAllAdmins(): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/user/getAllAdmins';
            let method = 'POST';

            if (debug) console.log("%cgetAllAdmins", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURL(url, method, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }

    public getAllMentors(): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/user/getAllMentors';
            let method = 'POST';

            if (debug) console.log("%cgetAllMentors", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURL(url, method, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }

    public getAllEditors(): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/user/getAllEditors';
            let method = 'POST';

            if (debug) console.log("%cgetAllEditors", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURL(url, method, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }

    public getAllSpecialUsers(course_type?: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/user/getAllSpecialUsers';
            let method = 'POST';

            let queryObject = course_type ? {
                course_type: course_type,
            } : {};
            let query = JSON.stringify(queryObject);

            if (debug) console.log("%cgetAllSpecialUsers ", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }

    public getAllCoursesAndAuthors(course_type?: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/user/getAllCoursesAndAuthors';
            let method = 'POST';

            let queryObject = course_type ? {
                course_type: course_type,
            } : {};
            let query = JSON.stringify(queryObject);

            if (debug) console.log("%cgetAllCoursesAndAuthors", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }

    public getAllCoursesAndMentors(course_type?: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/user/getAllCoursesAndMentors';
            let method = 'POST';

            let queryObject = course_type ? {
                course_type: course_type,
            } : {};
            let query = JSON.stringify(queryObject);

            if (debug) console.log("%cgetAllCoursesAndMentors", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }

    public getNumberOfAvailableTokens(): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/tokens/getNumberOfAvailableTokens';
            let method = 'POST';

            if (debug) console.log("%cgetNumberOfAvailableTokens", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURL(url, method, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }

    public removeAuthorFromCourse(userId: string, courseId: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/user/removeAuthorFromCourse';
            let method = 'POST';

            let queryObject = {
                userId: userId,
                courseId: courseId,
            }
            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%cremoveAuthorFromCourse", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    public removeMentorFromCourse(userId: string, courseId: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/user/removeMentorFromCourse';
            let method = 'POST';

            let queryObject = {
                userId: userId,
                courseId: courseId,
            }
            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%cremoveMentorFromCourse", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    public getRoleForUser(username: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/user/getRoleForUser';
            let method = 'POST';

            let queryObject = {
                username: username,
            }
            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%cgetRoleForUser", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    public userIsLoggedIn(): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/authentication/userIsLoggedIn';
            let method = 'POST';

            if (debug) console.log("%cuserIsLoggedIn", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLForUserIsLoggedIn(url, method).then(isSuccessful => {
                if (debug) console.log("%cUSER LOGIN STATUS", isSuccessful)
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    private static userDetailsPromise: Promise<any>;
    public getUserDetails(): Promise<any> {
        if (BrowserAdapter.userDetailsPromise) {
            return BrowserAdapter.userDetailsPromise;
        }
        return BrowserAdapter.userDetailsPromise = new Promise((resolve, reject) => {
            let url = this.URLBase + '/user/getUserDetails';
            let method = 'POST';

            if (debug) console.log("%cgetUserDetails", 'background: #ffbf00; color: black');


            this.newUtils.obtainJSONFromURL(url, method, false).then(isSuccessful => {
                //if(debug) console.log('%c GET USER DETAILS SUCCESS ', 'background: #222; color: black');
                resolve(isSuccessful);
            }).catch(error => {
                BrowserAdapter.userDetailsPromise = null;
                reject(error)
            });
        });
    }


    public setUserProgressSync(queryJSON: string) {
        let url = this.URLBase + '/user/setUserProgress';
        let method = 'POST';

        if (debug) console.log("%csetUserProgressSync", 'background: #ffbf00; color: black');

        var JSONContent = this.newUtils.obtainJSONFromURLWithQuerySync(url, method, queryJSON);
        return JSONContent;
    }


    public setUserProgressAsync(queryJSON: string): Promise<any> {
        return new Promise((resolve, reject) => {

            let url = this.URLBase + '/user/setUserProgress';
            let method = 'POST';

            if (debug) console.log("%csetUserProgressAsync", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, queryJSON, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });


        });
    }

    public getUserProgress(queryJSON: string): Promise<any> {
        return new Promise((resolve, reject) => {

            let url = this.URLBase + '/user/getUserProgress';
            let method = 'POST';

            if (debug) console.log("%cgetUserProgress", 'background: #ffbf00; color: black');


            this.newUtils.obtainJSONFromURLWithQuery(url, method, queryJSON, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });


        });
    }

    public getUserProgressForWholeCourse(courseId: any): Promise<any> {
        return new Promise((resolve, reject) => {

            let url = this.URLBase + '/user/getUserProgressForWholeCourse';
            let method = 'POST';
            let queryObject = {
                courseId: courseId,
            }
            let query = JSON.stringify(queryObject);
            /*Utils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                resolve(JSONContent);
            });*/

        });
    }

    public getUserDetailsByEmail(email: string): Promise<any> {
        return new Promise((resolve, reject) => {

            let url = this.URLBase + '/user/getUserDetailsByEmail';
            let method = 'POST';
            let queryObject = {
                email: email,
            }
            let query = JSON.stringify(queryObject);
            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                resolve(JSONContent);
            });

        });
    }

    public hasAnyProgress(): Promise<boolean> {
        return new Promise((resolve, reject) => {

            let url = this.URLBase + '/user/hasAnyProgress';
            let method = 'POST';

            if (debug) console.log("%chasAnyProgress", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURL(url, method, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }

    public userHasAccessForCourse(courseId: any): Promise<boolean> {
        return new Promise((resolve, reject) => {

            let url = this.URLBase + '/user/userHasAccessForCourse';
            let method = 'POST';

            let queryObject = {
                id: courseId,
            }
            let query = JSON.stringify(queryObject);

            if (debug) console.log("%cuserHasAccessForCourse", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }


    public getUserSettings(): Promise<any> {
        return new Promise((resolve, reject) => {

            let url = this.URLBase + '/user/getUserSettings ';
            let method = 'POST';
            let queryJSON = "";

            if (debug) console.log("%cgetUserSettings", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, queryJSON, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });


        });
    }

    public getFeedbackStatus(): Promise<any> {
        return new Promise((resolve, reject) => {

            let url = this.URLBase + '/user/getFeedbackStatus ';
            let method = 'POST';
            let queryJSON = "";

            if (debug) console.log("%cgetFeedbackStatus", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, queryJSON, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });


        });
    }

    public setFeedbackStatus(newStatus: string): Promise<any> {
        return new Promise((resolve, reject) => {

            let url = this.URLBase + '/user/setFeedbackStatus';
            let method = 'POST';


            var query_temp = {
                "feedbackNotification": newStatus,
            }

            let queryJSON = JSON.stringify(query_temp);

            if (debug) console.log("%csetFeedbackStatus", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, queryJSON, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });


        });
    }

    public saveUserSettings(higlightWholeParagraph: boolean, higlightDisabled: boolean, higlightCurrentPhrase: boolean, pause_on_code_listings: boolean, pause_on_try_it_yourselfs: boolean, pause_on_exercises: boolean, autoplay: boolean, autocontinue: boolean, discussions_code_of_conduct_shown: boolean, discussions_email_notifications_offered: boolean, discussions_offered: boolean): Promise<any> {
        return new Promise((resolve, reject) => {

            let valueHighlight = "phrase";
            if (higlightWholeParagraph) {
                valueHighlight = "paragraph";
            }
            else if (higlightDisabled) {
                valueHighlight = "none";
            }

            let url = this.URLBase + '/user/saveUserSettings';
            let method = 'POST';
            var query_temp = {
                "highlight": valueHighlight,
                "pause_on_code_listings": pause_on_code_listings,
                "pause_on_try_it_yourselfs": pause_on_try_it_yourselfs,
                "pause_on_exercises": pause_on_exercises,
                "autoplay": autoplay,
                "autocontinue": autocontinue,
                "discussions-code-of-conduct-shown": discussions_code_of_conduct_shown,
                "discussions-email-notifications-offered": discussions_email_notifications_offered,
                "discussions-offered": discussions_offered,
            }

            var query = JSON.stringify(query_temp);

            if (debug) console.log("%csaveUserSettings", 'background: #ffbf00; color: black');

            this.newUtils.sendJSONQueryToURL(url, method, query, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });


        });
    }

    public sendFeedback(subject: string, email: string, feedback: string, platform: string): Promise<any> {
        return new Promise((resolve, reject) => {

            let url = this.URLBase + '/user/sendFeedback ';
            let method = 'POST';
            var query_temp = {
                "subject": subject,
                "email": email,
                "feedback": feedback,
                "platform": platform,
            }

            var query = JSON.stringify(query_temp);

            if (debug) console.log("%csendFeedback", 'background: #ffbf00; color: black');

            this.newUtils.sendJSONQueryToURL(url, method, query, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });


        });
    }

    public requestSupport(subject: string, email: string, support: string, platform: string): Promise<any> {
        return new Promise((resolve, reject) => {

            let url = this.URLBase + '/user/requestSupport ';
            let method = 'POST';
            var query_temp = {
                "subject": subject,
                "email": email,
                "support": support,
                "platform": platform,
            }

            var query = JSON.stringify(query_temp);

            if (debug) console.log("%crequestSupport", 'background: #ffbf00; color: black');

            this.newUtils.sendJSONQueryToURL(url, method, query, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });


        });
    }

    public getExerciseGroup(id): Promise<any> {
        return new Promise((resolve, reject) => {

            let url = this.URLBase + '/module/getExerciseGroup';
            let method = 'POST';
            var query_temp = {
                "id": id.toString(),
            }

            var query = JSON.stringify(query_temp);

            if (debug) console.log("%cgetExerciseGroup", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }


    public unscrambleParagraph(courseId, unitIndex, moduleIndex, paragraphIndex, pret/*raživanje*/ = false): Promise<any> {
        return new Promise((resolve, reject) => {

            let url = this.URLBase + '/tokens/unscrambleParagraph';
            let method = 'POST';
            var query_temp = {
                "course_id": courseId,
                "unit_index": unitIndex,
                "module_index": moduleIndex,
                "paragraph_id": paragraphIndex,
                "pret": pret,
            }

            var query = JSON.stringify(query_temp);

            if (debug) console.log("%cunscrambleParagraph", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }

    public unscrambleModule(courseId, unitIndex, moduleIndex): Promise<any> {
        return new Promise((resolve, reject) => {

            let url = this.URLBase + '/tokens/unscrambleModule';
            let method = 'POST';
            var query_temp = {
                "course_id": courseId,
                "unit_index": unitIndex,
                "module_index": moduleIndex,
            }

            var query = JSON.stringify(query_temp);

            if (debug) console.log("%cunscrambleModule", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }

    public unscrambleUnit(courseId, unitIndex): Promise<any> {
        return new Promise((resolve, reject) => {

            let url = this.URLBase + '/tokens/unscrambleUnit';
            let method = 'POST';
            var query_temp = {
                "course_id": courseId,
                "unit_index": unitIndex,
            }

            var query = JSON.stringify(query_temp);

            if (debug) console.log("%cunscrambleUnit", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }

    public getVtt(courseId, unitIndex, moduleIndex): Promise<any> {
        return new Promise((resolve, reject) => {

            let url = this.URLBase + '/module/getVtt';
            let method = 'POST';
            var query_temp = {
                "course_id": courseId,
                "unit_index": unitIndex,
                "module_index": moduleIndex,
            }

            var query = JSON.stringify(query_temp);

            if (debug) console.log("%cgetVtt", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }

    public getModuleContent(courseId, unitIndex, moduleIndex): Promise<any> {
        return new Promise((resolve, reject) => {

            let url = this.URLBase + '/module/getModuleContent';
            let method = 'POST';
            var query_temp = {
                "course_id": courseId,
                "unit_index": unitIndex,
                "module_index": moduleIndex,
            }

            var query = JSON.stringify(query_temp);

            if (debug) console.log("%cgetModuleContent", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }

    private static authoredCoursesPromise: Promise<any>;
    public getAuthoredCourses(): Promise<any> {
        if (BrowserAdapter.authoredCoursesPromise) {
            return BrowserAdapter.authoredCoursesPromise;
        }

        return BrowserAdapter.authoredCoursesPromise = new Promise((resolve, reject) => {
            let url = this.URLBase + '/user/getAuthoredCourses';
            let method = 'POST';
            let queryJSON = "";

            if (debug) console.log("%cgetAuthoredCourses", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, queryJSON, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }

    private static mentoredCoursesPromise: Promise<any>;
    public getMentoredCourses(): Promise<any> {
        if (BrowserAdapter.mentoredCoursesPromise) {
            return BrowserAdapter.mentoredCoursesPromise;
        }

        return BrowserAdapter.mentoredCoursesPromise = new Promise((resolve, reject) => {
            let url = this.URLBase + '/user/getAuthoredCourses';
            let method = 'POST';
            let queryJSON = "";

            if (debug) console.log("%cgetAuthoredCourses", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, queryJSON, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }

    public search(query: string, productId: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/search/search';
            let method = 'POST';

            if (debug) console.log("%csearch", 'background: #ffbf00; color: black');

            jQuery.ajax({
                type: method,
                async: true,
                url: url,
                xhrFields: {
                    withCredentials: true
                },
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
                crossDomain: true,
                data: {
                    query: query,
                    product: productId,
                },
                success: function (output, status, xhr) {
                    resolve(output)
                },
                error: function (request, error) {
                    reject(error)
                },
            });

        });
    }

    public getAllSearchCategories(): Promise<any> {
        return new Promise((resolve, reject) => {

            let url = this.URLBase + '/search/getAllCategories';
            let method = 'POST';
            let queryJSON = "";

            if (debug) console.log("%cgetAllCategories", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, queryJSON, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });


        });
    }

    public uploadExerciseImage(base64image: string, imageName: string, externalId: string): Promise<any> {
        return new Promise((resolve, reject) => {

            let url = this.URLBase + '/s3courses/uploadExerciseImage';
            let method = 'POST';
            var query_temp = {
                "image": base64image,
                "imageName": imageName,
                "externalId": externalId,
            }
            var query = JSON.stringify(query_temp);

            if (debug) console.log("%cuploadExerciseImage", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {

                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }

    private static getSlugsPromiseMap: { [key: string]: Promise<any> } = {};
    public getSlugs(id?: string): Promise<any> {
        if (BrowserAdapter.getSlugsPromiseMap[id]) {
            return BrowserAdapter.getSlugsPromiseMap[id];
        }
        return BrowserAdapter.getSlugsPromiseMap[id] = new Promise((resolve, reject) => {

            let url = this.URLBase + '/course/getSlugs';
            let method = 'POST';

            var query_temp = {
                id: id ? id : null,
            }

            let queryJSON = JSON.stringify(query_temp);

            if (debug) console.log("%cgetSlugs", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, queryJSON, true).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => {
                BrowserAdapter.getSlugsPromiseMap[id] = null;
                reject(error)
            });
        });
    }


    public createScaffoldCourse(courseName: string, createOnMarketplace: boolean): Promise<any> {
        return new Promise((resolve, reject) => {

            let url = this.URLBase + '/course/createScaffoldCourse';
            let method = 'POST';

            var query_temp = {
                courseName: courseName,
                createOnMarketplace: createOnMarketplace,
            }

            let queryJSON = JSON.stringify(query_temp);

            if (debug) console.log("%ccreateScaffoldCourse", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, queryJSON, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(
                error => { reject(error) }
            );


        });
    }

    public transcribe(course_id: number, transcript_service: ITranscribeService, unit_index?: number, module_index?: number): Promise<any> {
        return new Promise((resolve, reject) => {

            let url = this.URLBase + '/transcription/transcribe';
            let method = 'POST';

            var query_temp: any = {
                "course_id": course_id,
                transcript_service: transcript_service,
            }
            if (unit_index != null) {
                query_temp = { ...query_temp, "unit_index": unit_index };
                if (module_index != null) {
                    query_temp = { ...query_temp, "module_index": module_index };
                }
            }

            let queryJSON = JSON.stringify(query_temp);

            if (debug) console.log("%ctranscribe", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, queryJSON, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(
                error => { reject(error) }
            );

        });
    }

    public getTranscriptionsForCourse(courseId): Promise<any> {
        return new Promise((resolve, reject) => {

            let url = this.URLBase + '/transcription/getTranscriptionsForCourse';
            let method = 'POST';

            var query_temp: any = {
                "courseId": courseId,
            }

            let queryJSON = JSON.stringify(query_temp);

            if (debug) console.log("%cgetTranscriptionsForCourse", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, queryJSON, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(
                error => { reject(error) }
            );
        });
    }

    public ecommerceHealthCheck(): Promise<any> {
        return new Promise((resolve, reject) => {

            let url = this.URLBase + '/healthCheck/ecommerceHealthCheck';
            let method = 'POST';

            var query_temp: any = {
            }

            let queryJSON = JSON.stringify(query_temp);

            this.newUtils.obtainJSONFromURLWithQuery(url, method, queryJSON, true).then(JSONContent => {
                if (debug) {
                    if (JSONContent && JSONContent.healthy)
                        console.log("%cecommerceHealthCheck", 'background: #009933; color: white');
                    else
                        console.log("%cecommerceHealthCheck", 'background: #ff5050; color: white');
                }
                resolve(JSONContent);
            }).catch(
                error => { reject(error) }
            );
        });
    }

    public createParagraphBreaksForCourse(courseId: number): Promise<any> {
        return new Promise((resolve, reject) => {

            let url = this.URLBase + '/course/createParagraphBreaksForCourse';
            let method = 'POST';
            let queryObject = {
                courseId: courseId,
            }
            let query = JSON.stringify(queryObject);

            if (debug) console.log("%ccreateParagraphBreaksForCourse", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }

    public saveStartEndDateForGroup(start_time: string, end_time: string, group_id: number): Promise<any> {
        return new Promise((resolve, reject) => {

            let url = this.URLBase + '/group/saveStartEndDateForGroup';
            let method = 'POST';
            let queryObject = {
                start_time: start_time,
                end_time: end_time,
                group_id: group_id,
            }
            let query = JSON.stringify(queryObject);

            if (debug) console.log("%csaveStartEndDateForGroup", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }

    /*public saveLanguageForGroup(language: string, group_id: number): Promise<any> {
        return new Promise((resolve, reject) => {

            let url = this.URLBase + '/group/saveLanguageForGroup';
            let method = 'POST';
            let queryObject = {
                language: language,
                group_id: group_id,
            }
            let query = JSON.stringify(queryObject);

            if (debug) console.log("%csaveLanguageForGroup", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }*/

    public assignMentorsToGroup(group_id: number, emails: string[], user_ids: number[]): Promise<any> {
        return new Promise((resolve, reject) => {

            let url = this.URLBase + '/group/assignMentorsToGroup';
            let method = 'POST';
            let queryObject = {
                group_id: group_id,
                emails: emails,
                user_ids: user_ids,
            }
            let query = JSON.stringify(queryObject);

            if (debug) console.log("%cassignMentorsToGroup", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }

    public removeMentorFromGroup(group_id: number, email: string, user_id: number): Promise<any> {
        return new Promise((resolve, reject) => {

            let url = this.URLBase + '/group/removeMentorFromGroup';
            let method = 'POST';
            let queryObject = {
                group_id: group_id,
                email: email,
                user_id: user_id,
            }
            let query = JSON.stringify(queryObject);

            if (debug) console.log("%cremoveMentorFromGroup", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }

    public assignUsersToGroup(group_id: number, emails: string[], user_ids: string[]): Promise<any> {
        return new Promise((resolve, reject) => {

            let url = this.URLBase + '/group/assignUsersToGroup';
            let method = 'POST';
            let queryObject = {
                group_id: group_id,
                emails: emails,
                user_ids: user_ids,
            }
            let query = JSON.stringify(queryObject);

            if (debug) console.log("%cassignUsersToGroup", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }

    public removeUserFromGroup(group_id: number, email: string, user_id: number): Promise<any> {
        return new Promise((resolve, reject) => {

            let url = this.URLBase + '/group/removeUserFromGroup';
            let method = 'POST';
            let queryObject = {
                group_id: group_id,
                email: email,
                user_id: user_id
            }
            let query = JSON.stringify(queryObject);

            if (debug) console.log("%cremoveUserFromGroup", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }

    public getLicensedUsersForCourse(course_id: number): Promise<any> {
        return new Promise((resolve, reject) => {

            let url = this.URLBase + '/user/getLicensedUsersForCourse';
            let method = 'POST';
            let queryObject = {
                course_id: course_id,
            }
            let query = JSON.stringify(queryObject);

            if (debug) console.log("%cgetLicensedUsersForCourse", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }

    public getLicenseTier(group_id: number): Promise<any> {
        return new Promise((resolve, reject) => {

            let url = this.URLBase + '/user/getLicenseTier';
            let method = 'POST';
            let queryObject = {
                group_id: group_id,
            }
            let query = JSON.stringify(queryObject);

            if (debug) console.log("%cgetLicenseTier", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }

    public getSessions(course_id: number): Promise<{ sessions: ISession[] }> {
        return new Promise<{ sessions: ISession[] }>((resolve, reject) => {

            let url = this.URLBase + '/course/getSessions';
            let method = 'POST';
            let queryObject = {
                course_id: course_id,
            }
            let query = JSON.stringify(queryObject);

            if (debug) console.log("%cgetSessions", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }

    public deleteGroup(course_id: number, group_id: number): Promise<any> {
        return new Promise((resolve, reject) => {

            let url = this.URLBase + '/group/deleteGroup';
            let method = 'POST';
            let queryObject = {
                course_id: course_id,
                group_id: group_id,
            }
            let query = JSON.stringify(queryObject);

            if (debug) console.log("%cdeleteGroup", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }

    public createNewGroup(course_id: number, sessionStartDate: string, sessionId: number, is_premium: boolean, name: string, start_time?: string): Promise<any> {
        return new Promise((resolve, reject) => {

            let url = this.URLBase + '/group/createNewGroup';
            let method = 'POST';
            let queryObject = {
                course_id: course_id,
                sessionId: sessionId,
                sessionStartDate: sessionStartDate,
                is_premium: is_premium,
                name: name,
                start_time: start_time,
            }
            let query = JSON.stringify(queryObject);

            if (debug) console.log("%ccreateNewGroup", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }

    public createNewGroupByUser(course_id: number, sessionStartDate: string, sessionId: number, name: string, is_premium: boolean): Promise<any> {
        return new Promise((resolve, reject) => {

            let url = this.URLBase + '/group/createNewGroupByUser';
            let method = 'POST';
            let queryObject = {
                course_id: course_id,
                sessionStartDate: sessionStartDate,
                name: name,
                is_premium: is_premium,
                sessionId: sessionId
            }
            let query = JSON.stringify(queryObject);

            if (debug) console.log("%ccreateNewGroupByUser", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }

    public getLogForCourse(course_id: number): Promise<any> {
        return new Promise((resolve, reject) => {

            let url = this.URLBase + '/course/getLogForCourse';
            let method = 'POST';
            let queryObject = {
                course_id: course_id,
            }
            let query = JSON.stringify(queryObject);

            if (debug) console.log("%cgetLogForCourse", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }

    public getGroupsForCourse(course_id: string): Promise<any> {
        return new Promise((resolve, reject) => {

            let url = this.URLBase + '/group/getGroupsForCourse';
            let method = 'POST';
            let queryObject = {
                course_id: course_id,
            }
            let query = JSON.stringify(queryObject);

            if (debug) console.log("%cgetGroupsForCourse", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false).then(JSONContent => {
                resolve(JSONContent);
            }).catch(error => { reject(error) });
        });
    }

    assignRoleToUser(username: string, role: string, course_id?: number): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/user/assignRoleToUser';
            let method = 'POST';

            let queryObject = {
                course_id: course_id || 1,
                username: username,
                role: role,
            }
            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%cassignRoleToUser", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    deleteRoleForUser(username: string, role: string, course_id?: number): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/user/deleteRoleForUser';
            let method = 'POST';

            let queryObject = {
                course_id: course_id || 1,
                username: username,
                role: role,
            }
            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%cdeleteRoleForUser", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    setDeliverableDate(group_id: number, module_id: number, deliverable_date: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/group/setDeliverableDate';
            let method = 'POST';

            let queryObject = {
                group_id: group_id,
                module_id: module_id,
                deliverable_date: deliverable_date,
            }
            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%csetDeliverableDate", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }


    submitSubmission(group_id: number, module_id: number, course_id: number, sessionId: number, github_url: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/userSubmission/submitSubmission';
            let method = 'POST';

            let queryObject = {
                group_id: group_id,
                module_id: module_id,
                course_id: course_id,
                github_url: github_url,
                sessionId: sessionId,
            }
            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%csubmitSubmission", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    getDeliverableDetails(module_id: number, course_id: number, group_id: number): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/group/getDeliverableDetails';
            let method = 'POST';

            let queryObject = {
                group_id: group_id,
                module_id: module_id,
                course_id: course_id,
            }
            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%cgetDeliverableDetails", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    getGroupsForUser(course_id: any): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/group/getGroupsForUser';
            let method = 'POST';

            let queryObject = {
                course_id: course_id,
            }
            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%cgetGroupsForUser", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    public setSubmissionStatus(submission_id: any, mentor_approved: boolean): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/userSubmission/setSubmissionStatus';
            let method = 'POST';

            let queryObject = {
                submission_id: submission_id,
                mentor_approved: mentor_approved,
            }
            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%csetSubmissionStatus", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    public addCertificationFeedbackMessage(group_id: any, feedback_message: string, is_mentor: boolean, mentor_id: any, user_id: any): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/certificationFeedback/addCertificationFeedbackMessage';
            let method = 'POST';

            let queryObject = {
                group_id: group_id,
                feedback_message: feedback_message,
                is_mentor: is_mentor,
                mentor_id: mentor_id,
                user_id: user_id,
            }
            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%caddCertificationFeedbackMessage", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    public getCertificationFeedbackMessagesForUserAndGroup(group_id: any, user_id: any): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/certificationFeedback/getCertificationFeedbackMessagesForUserAndGroup';
            let method = 'POST';

            let queryObject = {
                group_id: group_id,
                user_id: user_id,
            }
            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%cgetCertificationFeedbackMessagesForUserAndGroup", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    public getMentorUIUserData(group_id: any): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/mentor/getMentorUIUserData';
            let method = 'POST';

            let queryObject = {
                group_id: group_id,
            }
            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%cgetMentorUIUserData", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    public getUserSubmissions(groupId: any, onlyCurrentUser: boolean, fullDetails?: boolean, moduleId?: any): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/userSubmission/getUserSubmissions';
            let method = 'POST';

            let queryObject: any = {
                groupId: groupId,
                onlyCurrentUser: onlyCurrentUser,
                fullDetails: fullDetails,
            }
            if (moduleId) {
                queryObject = {
                    ...queryObject,
                    moduleId,
                }
            }
            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%cgetUserSubmissions", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    private static userInfoPromise: Promise<any>;
    public getUserInfo(): Promise<any> {
        if (BrowserAdapter.userInfoPromise) {
            return BrowserAdapter.userInfoPromise;
        }
        return BrowserAdapter.userInfoPromise = new Promise((resolve, reject) => {
            let url = this.URLBase + '/user/getUserInfo';
            let method = 'POST';

            let queryObject = {
            }
            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%cgetUserInfo", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => {
                BrowserAdapter.userInfoPromise = null;
                reject(error)
            });
        });
    }

    public setUserInfo(name?: string, listWeekdayTimes?: any, listWeekendTimes?: any, userInfo?: string, shareSkillLevel?: boolean, shareHours?: boolean, shareLocation?: boolean, skillLevels?: { id: number, level: number }[], selectedSkillDomains?: number[], languages?: string[], location?: string, locationText?: string, avatarUrl?: string, displayName?: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/user/setUserInfo ';
            let method = 'POST';

            const queryObject: any = {
            }
            if (name != null) {
                queryObject.name = name;
            }
            if (listWeekdayTimes != null) {
                queryObject.listWeekdayTimes = listWeekdayTimes;
            }
            if (listWeekendTimes != null) {
                queryObject.listWeekendTimes = listWeekendTimes;
            }
            if (userInfo != null) {
                queryObject.userInfo = userInfo;
            }
            if (shareSkillLevel != null) {
                queryObject.shareSkillLevel = shareSkillLevel;
            }
            if (shareHours != null) {
                queryObject.shareHours = shareHours;
            }
            if (shareLocation != null) {
                queryObject.shareLocation = shareLocation;
            }
            if (skillLevels != null) {
                queryObject.skillLevels = skillLevels;
            }
            if (selectedSkillDomains != null) {
                queryObject.selectedSkillDomains = selectedSkillDomains;
            }
            if (languages != null) {
                queryObject.languages = languages;
            }
            if (location != null) {
                queryObject.location = location;
            }
            if (locationText != null) {
                queryObject.locationText = locationText;
            }
            if (avatarUrl != null) {
                queryObject.avatarUrl = avatarUrl;
            }

            if (displayName != null) {
                queryObject.displayName = displayName;
            }

            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%csetUserInfo", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    public getAvailableGroupsForCourse(courseId: any): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/group/getAvailableGroupsForCourse ';
            let method = 'POST';

            let queryObject = {
                course_id: courseId,
            }
            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%cgetAvailableGroupsForCourse", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    public joinGroup(group_id: number): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/group/joinGroup ';
            let method = 'POST';

            let queryObject = {
                group_id: group_id,
            }
            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%cjoinGroup", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    public leaveGroup(group_id: number): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/group/leaveGroup ';
            let method = 'POST';

            let queryObject = {
                group_id: group_id,
            }
            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%cleaveGroup", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    lockGroup(group_id: number, lock: boolean): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/group/lockGroup ';
            let method = 'POST';

            let queryObject = {
                group_id: group_id,
                lock: lock,
            }
            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%clockGroup", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    public getUserLocation(): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/user/getUserLocation ';
            let method = 'POST';

            let queryObject = {

            }
            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%cgetUserLocation", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    public enrollCourse(courseId: any): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/course/enrollCourse ';
            let method = 'POST';

            let queryObject = {
                courseId: courseId
            }
            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%cenrollCourse", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    public setIsPremiumGroup(is_premium: boolean, group_id: number): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/group/setIsPremiumGroup ';
            let method = 'POST';

            let queryObject = {
                is_premium: is_premium,
                group_id: group_id,
            }
            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%csetIsPremiumGroup", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }


    public setForceDeliverableDates(is_forced: boolean, group_id: number): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/group/setForceDeliverableDates ';
            let method = 'POST';

            let queryObject = {
                force_deliverable_dates: is_forced,
                group_id: group_id,
            }
            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%csetForceDeliverableDates", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    public clearLiveProjectOwnership(user_id: number, course_id: number): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/user/clearPBCOwnership ';
            let method = 'POST';

            let queryObject = {
                user_id: user_id,
                course_id: course_id,
            }
            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%cclearLiveProjectOwnership", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    public uploadFiles(formData: FormData): Promise<any> {
        return new Promise(async (resolve, reject) => {
            let url = this.URLBase + '/module/uploadFiles';

            const response = await fetch(url, {
                method: "POST",
                body: formData,
                credentials: "include"
            });
            const myJson = await response.json();
            resolve(myJson);
        });
    }
    public deleteFile(key: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/module/deleteFile ';
            let method = 'POST';

            let queryObject = {
                key: key,
            }
            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%cdeleteSolutionFile", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    checkForNewLPLicenses(): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/user/checkForNewLPLicenses ';
            let method = 'POST';

            let queryObject = {
            }
            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%ccheckForNewLPLicenses", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    getEvents(courseId: number, groupId: number): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/calendar/getEvents ';
            let method = 'POST';

            let queryObject = {
                courseId: courseId,
                groupId: groupId,
            }
            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%cgetEvents", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    setEvents(courseId: number, groupId: number, events: ICalendarEvents[]): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/calendar/setEvents ';
            let method = 'POST';

            let queryObject = {
                courseId: courseId,
                groupId: groupId,
                events: events,
            }
            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%csetEvents", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }


    generateViewEvent(productId: number, sisterLicenseId: number, associatedLicenseId: number): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/event/view';
            let method = 'POST';

            let queryObject = {
                manningId: productId,
                sisterLicenseId: sisterLicenseId,
                associatedLicenseId: associatedLicenseId
            }
            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%cgenerateViewEvent", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    generateLivebookViewerViewEvent(productId: number, livebookViewerProductId: number): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/event/view';
            let method = 'POST';

            let queryObject = {
                manningId: productId,
                livebookViewerProductId: livebookViewerProductId,
                isLivebookViewer: true,
                originPlatformId: PlatformUtils.getOriginPlatformId(),
            }
            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%cgenerateViewEvent", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    getRecentActivityLog(groupId: number): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/recentActivityLog/getActivityLog';
            let method = 'POST';

            let queryObject = {
                "groupId": groupId
            }
            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%cgetRecentActivityLog", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    getUpcomingEvents(groupId: number): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/group/getUpcomingEvents';
            let method = 'POST';

            let queryObject = {
                "groupId": groupId
            }
            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%cgetUpcomingEvents", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    getUserCertificate(courseId: number): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/user/getUserCertificate';
            let method = 'POST';

            let queryObject = {
                courseId: courseId
            }
            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%cgetUserCertificate", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    getGroupMemberData(groupId: number): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/group/getGroupMembersData';
            let method = 'POST';

            let queryObject = {
                "groupId": groupId
            }
            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%cgetGroupMembersData", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    public uploadAvatarImage(imageBase64Content: string, imageName: string, isStaffUpload?: boolean, userId?: any): Promise<string> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/user/uploadAvatarImage';
            let method = 'POST';

            let queryObj: any = {
                imageBase64Content: imageBase64Content,
                imageName: imageName,
            };
            if (isStaffUpload) {
                queryObj = {
                    ...queryObj,
                    isStaffUpload: isStaffUpload,
                }
            }
            if (userId) {
                queryObj = {
                    ...queryObj,
                    userId: userId,
                }
            }

            let query = JSON.stringify(queryObj);

            if (debug) console.log("%cuploadAvatarImage", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, query, false)
                .then(data => resolve(data.url))
                .catch(error => resolve(""));
        });
    }

    private static skillDomainsPromise: Promise<any>;
    public getSkillDomains(): Promise<string> {
        if (BrowserAdapter.skillDomainsPromise) {
            return BrowserAdapter.skillDomainsPromise;
        }
        return BrowserAdapter.skillDomainsPromise = new Promise((resolve, reject) => {
            let url = this.URLBase + '/course/getSkillDomains';
            let method = 'POST';

            let queryObject = {
            }
            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%cgetSkillDomains", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, true).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => {
                BrowserAdapter.skillDomainsPromise = null;
                reject(error)
            });
        });
    }

    public locationGeocode(address: string): Promise<string> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/api/locations/geocode';
            let method = 'POST';

            let queryObject = {
                address: address
            }
            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%clocationGeocode", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    public getNumberOfLPUsers(courseId: any): Promise<string> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/course/getNumberOfLPUsers';
            let method = 'POST';

            let queryObject = {
                courseId: courseId
            }
            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%cgetNumberOfLPUsers", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    public getLpAnalytics(courseId: any): Promise<string> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/course/getLpAnalytics';
            let method = 'POST';

            let queryObject = {
                courseId: courseId
            }
            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%cgetLpAnalytics", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    public getOnlineUsers(): Promise<string> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/user/getOnlineUsers';
            let method = 'POST';

            let queryObject = {
            }
            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%cgetOnlineUsers", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    public submitExerciseResult(exerciseGroupId: number, exerciseResult: string): Promise<string> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/user/submitExerciseResult';
            let method = 'POST';

            let queryObject = {
                exerciseGroupId: exerciseGroupId,
                exerciseResult: exerciseResult,
            }
            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%csubmitExerciseResult", 'background: #ffbf00; color: black');
            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }


    public getMentorSettings(): Promise<string> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/user/getMentorSettings';
            let method = 'POST';

            let queryObject = {
            }
            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%cgetMentorSettings", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    public submitCertificateTest(moduleId: number, usedExerciseIds: number[], certificateTestSubmission: string, finalResult: any, exercisesSolved: string): Promise<string> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/user/submitCertificateTest';
            let method = 'POST';

            let queryObject = {
                moduleId: moduleId,
                usedExerciseIds: usedExerciseIds,
                certificateTestSubmission: certificateTestSubmission,
                finalResult: finalResult,
                exercisesSolved: exercisesSolved,
            }
            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%csubmitCertificateTest", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    public getCertificateTestResults(courseId: number): Promise<string> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/user/getCertificateTestResults';
            let method = 'POST';

            let queryObject = {
                courseId: courseId,
            }
            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%cgetCertificateTestResults", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    public saveMentorSettings(receiveImmediateEmails: boolean): Promise<string> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/user/saveMentorSettings';
            let method = 'POST';

            let queryObject = {
                receiveImmediateEmails: receiveImmediateEmails
            }
            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%csaveMentorSettings", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    public getSisterLicenses(courseId: number): Promise<string> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/course/getSisterLicenses';
            let method = 'POST';

            let queryObject = {
                courseId: courseId
            }
            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%cgetSisterLicenses", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    private static usersSisterLicensesPromise: Promise<any>;
    public getUsersSisterLicenses(forced: boolean = false): Promise<string> {
        if (BrowserAdapter.usersSisterLicensesPromise && !forced) {
            return BrowserAdapter.usersSisterLicensesPromise;
        }
        return BrowserAdapter.usersSisterLicensesPromise = new Promise((resolve, reject) => {
            let url = this.URLBase + '/user/getUsersSisterLicenses';
            let method = 'POST';

            let queryObject = {
            }
            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%cgetUsersSisterLicenses", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    public startSisterLicenses(courseId: number): Promise<string> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/course/startSisterLicenses';
            let method = 'POST';

            let queryObject = {
                courseId: courseId
            }
            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%cstartSisterLicenses", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    public startSisterLicensesAlt(courseId: number): Promise<string> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/course/startSisterLicensesAlt';
            let method = 'POST';

            let queryObject = {
                courseId: courseId
            }
            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%cstartSisterLicenses", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }


    public resetSisterLicense(userId: number, courseId: number): Promise<string> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/course/resetSisterLicense';
            let method = 'POST';

            let queryObject = {
                courseId: courseId,
                userId: userId,
            }
            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%cresetSisterLicense", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    public userCanStartCertificateTest(courseId: number): Promise<string> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/user/userCanStartCertificateTest';
            let method = 'POST';

            let queryObject = {
                courseId: courseId,
            }
            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%cuserCanStartCertificateTest", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    public addReviewers(course_id: number, reviewers: string[], group_id?: number): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/group/addReviewers';
            let method = 'POST';

            let queryObject = {
                productId: course_id,
                groupId: group_id,
                reviewers: reviewers
            }
            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%caddReviewers", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    cloneCourse(courseId: number): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = this.URLBase + '/course/cloneCourse';
            let method = 'POST';

            let queryObject = {
                courseId: courseId,
            }
            let jsonQuery = JSON.stringify(queryObject);

            if (debug) console.log("%ccloneCourse", 'background: #ffbf00; color: black');

            this.newUtils.obtainJSONFromURLWithQuery(url, method, jsonQuery, false).then(isSuccessful => {
                resolve(isSuccessful);
            }).catch(error => { reject(error) });
        });
    }

    private static liveBookCatalog: Promise<any>;
    public obtainLiveBookCatalog(): Promise<any> {
        if (BrowserAdapter.liveBookCatalog) {
            return BrowserAdapter.liveBookCatalog;
        }
        return BrowserAdapter.liveBookCatalog = new Promise((resolve, reject) => {
            (async () => {
                resolve(await (await fetch("https://livebook-qa.manning.com/api/catalog/getMediumCatalog?platform=browser-MacIntel")).json());
            })()
        });
    }
}


class Utils {

    static inititatedRefresh = null;

    public newRefreshLogin(): Promise<any> {
        return new Promise((resolve, reject) => {

            var _this2 = this;
            var result = false;

            if (!(Utils.inititatedRefresh == null)) {
                resolve(Utils.inititatedRefresh);
            }
            else {
                Utils.inititatedRefresh = new Promise((resolve, reject) => {
                    /*var site = getServerURL()+"/user/userIsLoggedInCAS?timestamp"+Date.now();
                    var myIframe:any = document.getElementById('myIFrame')
                    myIframe.src = site;*/
                    Utils.inititatedRefresh = null;
                    resolve(true);
                });

                resolve(Utils.inititatedRefresh)
            }
        });

    }

    public obtainJSONFromURLForUserIsLoggedIn(url, method): Promise<any> {
        return new Promise((resolve, reject) => {

            var xhr = this.createCORSRequest(method, url);
            xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
            xhr.timeout = 10000; // time in milliseconds
            xhr.onload = function (result) {
                var x: any = result.target;
                if (x != null) {
                    if (x.status == 200) {
                        let resultData = x.response;
                        var parsed = JSON.parse(resultData);
                        if (parsed.error != null && parsed.error != "") {
                            resolve({ loggedIn: false })
                        }
                        else if (x.response != null) {
                            resolve({ loggedIn: parsed.loggedIn });
                        }
                        else {
                            resolve({ loggedIn: false })
                        }
                    }
                    /*else if(x.status == 302)
                    {
                        console.log("STATUS 302")
                    }*/
                    else {
                        resolve({ loggedIn: false })
                    }
                }
            };
            xhr.ontimeout = function (e) {
                resolve({ loggedIn: false })
            };

            xhr.onerror = function (error) {
                resolve({ loggedIn: false })
            };

            xhr.send();
        });
    }

    public obtainJSONFromURL(url, method): Promise<any> {
        return new Promise((resolve, reject) => {

            var xhr = this.createCORSRequest(method, url);
            xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
            /*xhr.setRequestHeader('Content-Type','application/x-www-form-urlencoded');     */

            var _this2 = this;
            xhr.onload = function (result) {
                var x: any = result.target;
                if (x != null) {
                    if (x.status == 200) {
                        let resultData = x.response;
                        var parsed = jQuery.parseJSON((resultData))
                        if (parsed.error != null && parsed.error != "") {
                            reject(parsed.error);
                        }
                        else {
                            resolve(parsed);
                        }
                    }
                    else if (x.status == 401 || x.status == 403) {
                        console.log(x.status)
                        reject("Unfortunatelly, you do not have permission to access this page!");
                    }
                    else {
                        console.log(x.status + " 2")
                        reject(x.status);
                        _this2.logoutUsingLS();
                    }
                }
            };

            xhr.onerror = function (error) {
                let additional = "";
                const e: any = error;
                additional += e.statusText != null ? " " + e.statusText : "";
                additional += e.status != null ? " " + e.status : "";
                reject("#" + url + additional);
            };

            xhr.send();
        });
    }




    public obtainJSONFromURLWithQuery(url, method, query, shouldSkipCredentials = false): Promise<any> {
        return new Promise((resolve, reject) => {

            let xhr;
            if (shouldSkipCredentials) {
                xhr = this.createCORSRequestWithoutCredentials(method, url);
            } else {
                xhr = this.createCORSRequest(method, url);
            }

            let _this2 = this;
            xhr.onload = function (result) {
                var x: any = result.target;
                if (x != null) {
                    let resultData = x.response;
                    if (x == 500) {
                        if (debug) alert("Backend api " + url);
                        reject("Backend responded with" + 500)
                    }
                    else if (x.status == 200) {
                        if (_this2.isJSON(resultData)) {
                            let resultData = x.response;
                            var parsed = jQuery.parseJSON((resultData))
                            if (parsed.error != null && parsed.error != "") {
                                reject(parsed.error);
                            }
                            else {
                                resolve(parsed);
                            }
                        }
                        else {
                            reject("Obtained data is not in correct JSON format" + resultData)
                        }
                    }
                    else if (x.status == 401 || x.status == 403) {
                        console.log(x.status)
                        reject(REJECT_PERMISSION_ERROR_403_401);
                    }
                    else {
                        reject(x.status);
                    }
                } else {
                    reject("Unknown error")
                }

            };

            xhr.onerror = function (error) {
                let additional = "";
                const e: any = error;
                additional += e.statusText != null ? " " + e.statusText : "";
                additional += e.status != null ? " " + e.status : "";
                reject("#" + url + additional);
            };

            xhr.send(query);
        });
    }


    public obtainJSONFromURLWithQuerySync(url, method, query) {

        var xhr = this.createCORSRequestSync(method, url);
        var _this2 = this;
        xhr.onload = function (result) {
            var x: any = result.target;
            if (x != null) {
                let resultData = x.response;
                if (x.status == 200) {
                    if (_this2.isJSON(resultData)) {
                        var parsed = jQuery.parseJSON(resultData)

                        if (parsed.error != null && parsed.error != "") {
                            return (parsed.error);
                        }
                        else {
                            return (parsed)
                        }
                    }
                }
                else if (x.status == 401 || x.status == 403) {
                    console.log(x.status)
                    return (REJECT_PERMISSION_ERROR_403_401);
                }
                else {
                    return (x.status);
                }
            }

        };

        xhr.onerror = function (error) {
            console.log("%cCould not fetch data (4)", 'background: #ffbf00; color: black', error, url);
            _this2.logoutUsingLS();
        };

        xhr.send(query);

    }



    public sendJSONQueryToURL(url, method, query): Promise<boolean> {
        return new Promise((resolve, reject) => {

            var xhr = this.createCORSRequest(method, url);
            var _this2 = this;
            xhr.onload = function (result) {
                var x: any = result.target;
                if (x != null) {
                    if (x.status == 200) {
                        let parsedResult = JSON.parse(x.response);
                        if (parsedResult.result == "200 Success" || parsedResult.result == "success") {
                            resolve(parsedResult)
                        }
                        else {
                            resolve(false)
                        }
                    }
                    else if (x.status == 401 || x.status == 403) {
                        console.log(x.status)
                        reject(REJECT_PERMISSION_ERROR_403_401);
                    }
                    else {
                        reject(x.status);
                    }
                }
                else {
                    reject(result)
                }
            };

            xhr.onerror = function (error) {
                let additional = "";
                const e: any = error;
                additional += e.statusText != null ? " " + e.statusText : "";
                additional += e.status != null ? " " + e.status : "";
                reject("#" + url + additional);
            };

            xhr.send(query);
        });
    }

    public sendJSONQueryToURLWithErrorResponse(url, method, query): Promise<boolean> {
        return new Promise((resolve, reject) => {

            var xhr = this.createCORSRequest(method, url);
            var _this2 = this;
            xhr.onload = function (result) {
                var x: any = result.target;
                if (x != null) {
                    if (x.status == 200) {
                        let parsedResult = JSON.parse(x.response);
                        if (parsedResult.result == "200 Success" || parsedResult.result == "success") {
                            resolve(parsedResult)
                        }
                        else if (parsedResult.error) {
                            resolve(parsedResult)
                        }
                        else {
                            resolve(false)
                        }
                    }
                    else if (x.status == 401 || x.status == 403) {
                        console.log(x.status)
                        reject(REJECT_PERMISSION_ERROR_403_401);
                    }
                    else {
                        reject(x.status);
                    }
                }
                else {
                    reject(result)
                }
            };

            xhr.onerror = function (error) {
                let additional = "";
                const e: any = error;
                additional += e.statusText != null ? " " + e.statusText : "";
                additional += e.status != null ? " " + e.status : "";
                reject("#" + url + additional);
            };

            xhr.send(query);
        });
    }


    public sendJSONQueryToURLWithReloginAttempt(url, method, query): Promise<boolean> {
        return new Promise((resolve, reject) => {

            var xhr = this.createCORSRequest(method, url);
            xhr.onload = function (result) {
                var x: any = result.target;
                if (x != null) {
                    if (x.responseURL.indexOf("login/ajaxSuccess") !== -1) {
                        alert("Unexpected error. Please click cancel and try again!")
                    }
                    else if (x.status == 200) {
                        let parsedResult = JSON.parse(x.response);
                        if (parsedResult.error) {
                            reject(parsedResult.error);
                        }
                        else if (parsedResult.result == "200 Success") {
                            resolve(parsedResult)
                        }
                        else {
                            resolve(false)
                        }
                    }
                    else if (x.status == 401 || x.status == 403) {
                        console.log(x.status)
                        reject(REJECT_PERMISSION_ERROR_403_401);
                    }
                    else {
                        reject(x.status);
                    }
                }
                else {
                    reject(result)
                }
            };

            xhr.onerror = function (error) {
                console.log("%cCould not fetch data (6)", 'background: #ffbf00; color: black', error, url);
                reject(401);
            };

            xhr.send(query);
        });
    }


    public obtainResultFromJSONOnS3Server(url): Promise<any> {
        return new Promise((resolve, reject) => {
            try {

                jQuery.getJSON(url).done(function (data, textStatus, jqXHR) {
                    resolve(data)
                })
                    .fail(function (jqXHR, textStatus, errorThrown) {
                        resolve({})
                    });
            }
            catch (e) {
                resolve({})
            }

        });
    }


    public createCORSRequest(method: string, url: string) {
        var xhr = new XMLHttpRequest();
        xhr.withCredentials = true;

        xhr.getAllResponseHeaders()

        var win: any = window;
        if ("withCredentials" in xhr) {
            // Most browsers.
            xhr.open(method, url, true);
            xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        } else if (typeof win.XDomainRequest != "undefined") {
            // XDomainRequest for IE.
            xhr = new win.XDomainRequest();
            xhr.open(method, url, false);
            xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        }
        else {
            // CORS not supported.
            xhr = null;
        }

        return xhr;
    };

    public createCORSRequestWithoutCredentials(method: string, url: string) {
        var xhr = new XMLHttpRequest();
        xhr.withCredentials = false;

        xhr.getAllResponseHeaders()

        var win: any = window;
        if ("withCredentials" in xhr) {
            // Most browsers.
            xhr.open(method, url, true);
            xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        } else if (typeof win.XDomainRequest != "undefined") {
            // XDomainRequest for IE.
            xhr = new win.XDomainRequest();
            xhr.open(method, url, false);
            xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        }
        else {
            // CORS not supported.
            xhr = null;
        }

        return xhr;
    };


    public createCORSRequestSync(method: string, url: string) {
        var xhr = new XMLHttpRequest();
        xhr.withCredentials = true;


        xhr.getAllResponseHeaders()

        var win: any = window;
        if ("withCredentials" in xhr) {
            // Most browsers.
            xhr.open(method, url, false);
            xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        } else if (typeof win.XDomainRequest != "undefined") {
            // XDomainRequest for IE.
            xhr = new win.XDomainRequest();
            xhr.open(method, url, false);
            xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        }
        else {
            // CORS not supported.
            xhr = null;
        }
        return xhr;
    };





    public isJSON(test: string) {

        try {
            JSON.parse(test);
        } catch (e) {
            return false;
        }
        return true;
    }

    public logoutUsingLS() {
        if (forcedRefresh == true) {
            const numberOfAllowedRefreshes = 4;
            const is_root = location.pathname == "/";
            const is_editModule = location.href.indexOf("/editmodule/") !== -1
            if (!is_editModule) {
                localStorage.setItem("forceLogOut", "true");
            }

            if (!is_editModule) {
                if (!is_root) {
                    console.log("%credirect2", 'background: #ffbf00; color: black');
                    location.href = "/?service=" + location.href;
                }
                else {
                    let refreshCounter = Number(getParameterByName("refresh")) || 1;
                    refreshCounter++;
                    if (refreshCounter > -1 && refreshCounter < numberOfAllowedRefreshes) {
                        insertParameter("refresh", refreshCounter);
                    }
                    else {
                        alert("There was an unexpected error!")
                    }

                }

            }
        }
    }

}

/*var ba = new BrowserAdapter();
ba.getURLBase();*/

//export default BrowserAdapter;
